const P = ({
  children,
  bold = false,
  size = 'default',
  style,
  className,
  color,
  fontWeightCustom,
  onClick,
  testId,
}) => {
  let fontSize
  switch (size) {
    case 'small':
      fontSize = '12px'
      break
    case 'regular':
      fontSize = '14px'
      break
    case 'default':
      fontSize = '16px'
      break
    case 'medium':
      fontSize = '18px'
      break
    case 'large':
      fontSize = '20px'
      break
    case 'xlarge':
      fontSize = '24px'
      break
    default:
      fontSize = '16px'
      break
  }

  const fontWeight = fontWeightCustom
    ? fontWeightCustom
    : bold
      ? 'bold'
      : 'normal'

  return (
    <p
      style={{
        fontSize,
        fontWeight,
        margin: 0,
        padding: 0,
        color: color,
        ...style,
      }}
      className={className}
      onClick={onClick}
      {...(testId ? { 'data-testid': testId } : {})}
    >
      {children}
    </p>
  )
}

export default P
